import { BehaviorSubject } from 'rxjs';

import { fetchWrapper } from '@helpers';

const usuarioPedidosSubject = new BehaviorSubject(null);
const baseUrl = `/usuarioPedido`;


export const usuarioPedidosService = {
    agregarArticuloPedido,
    eliminarArticuloPedido,
    modificarArticuloPedido,
    getPedidoByIdUsuarioNotFinalized,
    finalizarPedido,
    getPedidosAll,
    getPedidosByIdUsuario,
    modificarSnYaLoPrepare,
    getPedidoDetallesByIdUsuarioPedido,
    usuarioPedidos: usuarioPedidosSubject.asObservable(),
    get usuarioPedidosSubjectValue () { return usuarioPedidosSubject.value }
   
};

function agregarArticuloPedido(params) {
    return fetchWrapper.post(`${baseUrl}/agregar-articulo-pedido`, params);
}

function eliminarArticuloPedido(params) {
    return fetchWrapper.post(`${baseUrl}/eliminar-articulo-pedido`, params);
}

function modificarArticuloPedido(params) {
    return fetchWrapper.post(`${baseUrl}/modificar-articulo-pedido`, params);
}





function getPedidoByIdUsuarioNotFinalized (idUsuario) {
    return fetchWrapper.get(`${baseUrl}/get-by-idUsuario-not-finalized/${idUsuario}`);
}

 //tengo que hacer este metodo en vs 2019
function finalizarPedido(params) {
    return fetchWrapper.post(`${baseUrl}/finalizar-pedido`, params);
}


function getPedidosAll(params) {
    return fetchWrapper.post(`${baseUrl}/get-pedidos-all`, params );
}

function getPedidosByIdUsuario(params) {
    return fetchWrapper.post(`${baseUrl}/get-pedidos-by-idUsuario`, params );
}

function modificarSnYaLoPrepare(params) {
    return fetchWrapper.post(`${baseUrl}/modificar-snYaLoPrepare`, params );
}

function getPedidoDetallesByIdUsuarioPedido(params) {
    return fetchWrapper.post(`${baseUrl}/get-pedidoDetalles-by-idUsuarioPedido`, params );
}








